// src/components/customer/PortalPopup.jsx
// Popup shown to a targeted customer in the Customer Portal (Portal Personalisation Campaigns).
// PortalPopupCard is also used by the admin editor as the live preview, so what the admin sees
// is what the customer gets.
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import '../../styles/portal-popup.css';

export function PortalPopupCard({ imageUrl, headerText, bodyText, ctaText, onCta, onClose }) {
  return (
    <div className={`portal-popup-card${imageUrl ? '' : ' portal-popup-card--no-image'}`} role="dialog" aria-modal="true" aria-label={headerText || 'Message'}>
      {onClose && (
        <button type="button" className="portal-popup-close" onClick={onClose} aria-label="Close">
          ×
        </button>
      )}
      {imageUrl && (
        <div className="portal-popup-image-wrap">
          <img className="portal-popup-image" src={imageUrl} alt="" />
        </div>
      )}
      <div className="portal-popup-content">
        <h3 className="portal-popup-header">
          {headerText || <span className="portal-popup-placeholder">Header text…</span>}
        </h3>
        <p className="portal-popup-body">
          {bodyText || <span className="portal-popup-placeholder">Body text…</span>}
        </p>
        <button type="button" className="portal-popup-cta" onClick={onCta}>
          {ctaText || 'Call to action'}
        </button>
      </div>
    </div>
  );
}

function PortalPopup({ popup, onCta, onClose }) {
  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  if (!popup) return null;

  // Rendered on <body> so no page container (overflow, transforms) can clip or offset it
  return createPortal(
    <div
      className="portal-popup-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <PortalPopupCard
        imageUrl={popup.imageUrl}
        headerText={popup.headerText}
        bodyText={popup.bodyText}
        ctaText={popup.ctaText}
        onCta={onCta}
        onClose={onClose}
      />
    </div>,
    document.body
  );
}

export default PortalPopup;
